const columnTabelConfig = [
  {
    key: 'checkbox',
    label: '',
    thClass: 'pr-0 align-middle',
    tdClass: 'pr-0',
  },
  {
    key: 'date',
    label: 'Date',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '180px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '180px',
      textAlign: 'left',
    },
    tdClass: 'text-[#828282]',
  },
  {
    key: 'name',
    label: 'Partner',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '150px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]',
  },
  {
    key: 'card_uuid',
    label: 'Cards',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdClass: 'text-[#333333]',
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '200px',
      textAlign: 'left',
    },
  },
  {
    key: 'monit_balance',
    label: 'Monit Balance',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '200px',
      textAlign: 'left',
    },
  },
  {
    key: 'komcard_balance',
    label: 'Komcards Balance',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '200px',
      textAlign: 'left',
    },
  },
  {
    key: 'type_ticket',
    label: 'Type Issue',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '150px',
      textAlign: 'left',
    },
  },
]

const columnMissingTransactionsConfig = [
  {
    key: 'date',
    label: 'Date',
    thClass: 'align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '200px',
      textAlign: 'left',
    },
  },
  {
    key: 'description',
    label: 'Description',
    thClass: 'align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '200px',
      textAlign: 'left',
    },
  },
  {
    key: 'transaction_id',
    label: 'Transaction ID',
    thClass: 'align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '150px',
      textAlign: 'left',
    },
  },
  {
    key: 'amount',
    label: 'Amount',
    thClass: 'align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '150px',
      textAlign: 'left',
    },
  },
  {
    key: 'missing_issue',
    label: 'Missing Issue',
    thClass: 'align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '150px',
      textAlign: 'left',
    },
  },
  {
    key: 'action',
    label: 'Action',
    thClass: 'align-middle text-center',
    tdClass: 'text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '150px',
      textAlign: 'left',
    },
  },
]

const tabsConfig = [
  { key: 'new_issue', label: 'New Issue', icon: 'k-warning-2' },
  { key: 'on_process', label: 'On Process', icon: 'k-status' },
  { key: 'solved', label: 'Solved', icon: 'k-tick-circle' },
]

const ticketClassMap = {
  'Balance Difference': 'bg-[#E5F3FC] text-[#1875A7]',
  'Missing Transaction': 'bg-[#FDF2F2] text-[#E12A2A]',
}

const TICKET_CLASS_DEFAULT = 'bg-gray-100 text-gray-800'

const OPTIONS_PAGE = [25, 50, 100, 200]

// TODO: Remove mock data after API integration
const mockMissingTransactionItems = [
  {
    date: '2025-10-13 16:11:05',
    description: 'FACEBK 890',
    transaction_id: 'c3e23834-2811-4f0a-99ef-ab09fb0f5951',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 920',
    transaction_id: 'dd5b1dbd-35bd-47f4-bfe1-ad36e6f58daf',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 482',
    transaction_id: '96d3369f-4207-43dc-8111-e0a143afa858',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 467',
    transaction_id: '6c0d4bf3-64cc-4ade-b092-6ccc8eb1f170',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 17',
    transaction_id: 'bd5fc444-bc55-4e7c-9e84-0d5f15e2058f',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 749',
    transaction_id: '013e69fe-4eb0-4313-abec-468613ffb615',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 631',
    transaction_id: 'b429fd90-074b-4927-9769-8890a604d793',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 112',
    transaction_id: 'a9cfd112-74b4-4927-9769-8890a604d793',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 543',
    transaction_id: 'e7235543-74b4-4927-9769-8890a604d793',
    amount: -1000,
    missing_issue: 'Monit',
  },
  {
    date: '2025-10-13 16:11:05',
    description: 'YOUTUBE 998',
    transaction_id: 'c1189998-74b4-4927-9769-8890a604d793',
    amount: -1000,
    missing_issue: 'Monit',
  },
]

export {
  columnTabelConfig,
  columnMissingTransactionsConfig,
  tabsConfig,
  ticketClassMap,
  TICKET_CLASS_DEFAULT,
  OPTIONS_PAGE,
  mockMissingTransactionItems,
}
export default columnTabelConfig
